import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { getFontTokenStyle } from '@koaly/mixins';
import { withExtra } from '@koaly/with-extra';
import React from 'react';
import styled from 'styled-components';

const StyledLink = styled.a `
  /* Reset */
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  text-decoration: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: none;

  ${({ size, variant }) => getFontTokenStyle('link', size, variant, 'bold')};

  cursor: pointer;
`;
const Link = withExtra((_a, ref) => {
    var { href, children, as, size, tabIndex, className, variant, onClick } = _a, other = __rest(_a, ["href", "children", "as", "size", "tabIndex", "className", "variant", "onClick"]);
    return (React.createElement(StyledLink, Object.assign({ as: as, className: className, tabIndex: tabIndex, href: href, ref: ref, variant: variant, size: size, onClick: onClick }, other), children));
}, { name: 'Link' });
Link.defaultProps = {
    variant: 'primary',
    size: 'medium',
};

export { Link, StyledLink };
//# sourceMappingURL=Link.js.map
